import { Component, OnInit } from '@angular/core';
import { CustomerService } from './../../POSServices/Customers/customer.service';
import { DatePipe } from '@angular/common';
import { CommonFunctionService, UserPOSData } from '../../../services/Common/common-function.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../environments/environment';
const swal = require('sweetalert');
import { Router } from '@angular/router';
import { HomeserviceService } from '../../POSServices/Home/homeservice.service';
@Component({
  selector: 'app-poshome',
  templateUrl: './poshome.component.html',
  styleUrls: ['./poshome.component.scss']
})
export class POSHomeComponent implements OnInit {
  OrderListlength: any;;
  todate1: any;
  Fromdate1: any;
  private newAttribute: any = {};
  Paymenturlurl: any;
  posId: any;
  completeorders = [];
  temp = [];
  pendingorders = [];
  pendingorderslist = [];
  pospendingOrdersList: boolean = true;
  poscompletedOrdersList: boolean = false;
  activetab: any = 'tab11';
  tab12: any;
  currency: any;
  constructor(private service: CustomerService, private commonfunction: CommonFunctionService, private router: Router, private homeservice: HomeserviceService,) {
   


  }

  ngOnInit() {
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.currency = this.commonfunction.GetCurrencysymbol();
    this.posId = merchantdata.PosSubscriptionId;
    
    // this.completeorderlist();
    // this.penndingorderlist();
    // this.copyToClipboard("P0001323") 
    this.itemslist()
  }


  itemslist() {
    this.GetordrList((data) => {
      // this.GetordrList = _clone(data)
      // this.OrderListlength=this.GetordrList.length;
      // localStorage.setItem('orderlength', this.OrderListlength);
      // if(this.GetordrList.length>0)
      // {
      //     this.completeorderlist();
      //   this.penndingorderlist();
      // }
      // else{
      //   this.router.navigate(["/pos/setup"]);
      // }
    });
  }

  penndingorderlist() {
    this.GetPendingOrderList((data) => {
      // cache our list
      // this.temp = _clone(data);
      //      this.pendingorders = _clone(data);

      // for(let i=0; i<this.pendingorders.length;i++)
      // {
      //   var orderId=this.pendingorders[i].orderId;
      //   var lineItemCount=this.pendingorders[i].lineItemCount;
      //   var totalNetAmount=this.pendingorders[i].totalNetAmount;
      //   var dateTime=this.pendingorders[i].dateTime;
      //   var url=environment.OrderUrl+orderId;
      //   var id=this.pendingorders[i].id;
      //   this.newAttribute = {id,url,orderId,lineItemCount,totalNetAmount,dateTime};
      //   this.pendingorderslist.push(this.newAttribute); 

      // }

      // this.pendingorders = _clone(this.pendingorderslist);
    });
  }

  completeorderlist() {
    this.GetCompleteOrderList((data) => {
      // cache our list
      this.temp = _clone(data);
      this.completeorders = _clone(data);
    });

  }

  GetCompleteOrderList(cb) {
    this.homeservice.GetOrderDashBoardListUrl(this.posId).subscribe(data => {

      if (data != null) {
        this.temp = _clone(data);
        this.completeorders = _clone(data);
      }
    });
    // const req = new XMLHttpRequest();

    // req.open('GET',environment.GetOrderDashBoardListUrl + "?PosSubscriptionId=" + this.posId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    // };

    // req.send();
  }

  GetPendingOrderList(cb) {

    this.homeservice.GetPenddingOrderListUrl(this.posId).subscribe(data => {

      if (data != null) {
        this.pendingorders = _clone(data);
        for (let i = 0; i < this.pendingorders.length; i++) {
          var orderId = this.pendingorders[i].OrderId;
          var lineItemCount = this.pendingorders[i].LineItemCount;
          var totalNetAmount = this.pendingorders[i].TotalNetAmount;
          var dateTime = this.pendingorders[i].DateTime;
          var url = environment.OrderUrl + orderId;
          var id = this.pendingorders[i].Id;
          this.newAttribute = { id, url, orderId, lineItemCount, totalNetAmount, dateTime };
          this.pendingorderslist.push(this.newAttribute);

        }

        this.pendingorders = _clone(this.pendingorderslist);
      }
    });

    // req.open('GET',environment.GetPenddingOrderListUrl + "?PosSubscriptionId=" + this.posId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    // };

    // req.send();
  }
  // copyurl(url)
  // {
  //   alert(url)
  //  swal("Added", "url", "success");  

  // }
  // copyToClipboard(element) {
  //   element.select();
  //   document.execCommand('copy');
  // }
  copyurl(url) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    swal("Process Payment Url", "Copied", "success");
  }

  GetordrList(cb) {
    this.Fromdate1 = "2017-01-01";
    this.todate1 = new Date().toISOString().slice(0, 10);
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    let form = {

      PosSubscriptionId: this.posId,
      FromDate: this.Fromdate1,
      ToDate: this.todate1,
      transactionStatus: 0,
      TransactionId: "",
      Amount: 0,
      AmountCheck: "",
      OrderStatus: 0,
      OrderId: "",
      PaymentType: 0,

    };
    this.homeservice.FilteringOrderDetails(form).subscribe(data => {
      if (data != null) {
        this.GetordrList = _clone(data)
        this.OrderListlength = this.GetordrList.length;
        localStorage.setItem('orderlength', this.OrderListlength);
        if (this.GetordrList.length > 0) {
          this.completeorderlist();
          this.penndingorderlist();
        }
        else {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
    // const req = new XMLHttpRequest();
    // req.open('GET',
    //   environment.FilteringOrderDetails + "?PosSubscriptionId=" +  this.posId+ "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&transactionStatus=" + 0
    //   + "&TransactionId=" + "" +"&Amount=" + 0 + "&AmountCheck=" + "" +"&OrderStatus="+0+"&OrderId="+""+"&PaymentType="+0);
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
    // req.send();
  }


  //   const req = new XMLHttpRequest();
  //   req.open('GET',environment.GetordermanagementListUrl + "?PosSubscriptionId=" + this.posId);
  //   req.onload = () => {
  //       cb(JSON.parse(req.response));

  //       };


  //   req.send();
  // }
  pendingOrderList() {
    this.pospendingOrdersList = !this.pospendingOrdersList;
    this.poscompletedOrdersList = false;
    this.activetab = 'tab11';
  }
  completedOrderList() {
    this.poscompletedOrdersList = !this.poscompletedOrdersList;
    this.pospendingOrdersList = false;
    this.activetab = 'tab12';
  }
}

